<template>
    <div class="network-access">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="networkAccess.accessible" class="display-block">
                        <a :href="networkAccess.accessibleUrl">
                            {{networkAccess.accessible.fullName}}
                        </a>

                        <span v-if="accessible" v-html="accessible.enrolledLabel"></span>

                        <span v-if="networkAccess.archivedLabel"
                              v-html="networkAccess.archivedLabel"></span>
                    </h4>
                    <h4 v-else class="display-block">
                        Grant Network Access
                    </h4>

                    <h5 v-if="project.id">
                        <a :href="'/properties/' + project.property_id">
                            Network Access - {{project.name}}
                        </a>
                    </h5>

                    <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                </header>

                <div class="row" v-if="networkAccess.id && networkCredential.id && !loading">
                    <div class="col-xs-6">
                        <dl>
                            <dt>Network Credential</dt>
                            <dd>
                                <a :href="'/networkCredentials/' + networkCredential.id">
                                    {{networkCredential.username}}
                                </a>
                            </dd>

                            <dt>Network Access <a :href="networkAccess.accessUrl">(Link)</a></dt>
                            <dd v-clipboard="() => networkAccess.accessUrl"
                                @success="$notify( {
                                    type: 'success',
                                    placement: 'top-left',
                                    title: 'Copied',
                                    } )">
                                <a href="javascript://void(0)">Copy Link</a>
                            </dd>

                            <dt>{{networkAccess.accessibleName}}</dt>
                            <dd>
                                <a :href="networkAccess.accessibleUrl">
                                    {{networkAccess.accessible.fullName}}
                                    <span
                                        v-if="networkAccess.accessible.unit">
                                        (Apt: {{networkAccess.accessible.unit}})
                                    </span>
                                </a>
                            </dd>

                            <dt v-if="networkCredential.ssid && networkCredential.ssid.address">Address</dt>
                            <dd v-if="networkCredential.ssid && networkCredential.ssid.address"
                                v-html="networkCredential.ssid.address.address_html">
                            </dd>
                        </dl>
                    </div>

                    <div class="col-xs-6">
                        <dl>
                            <dt>SSID</dt>
                            <dd v-if="networkCredential.ssid.name">
                                {{networkCredential.ssid.name}}
                                <a href="javascript://void(0)"
                                   v-clipboard="() => networkCredential.ssid.name"
                                   @success="$notify( { type: 'success', placement: 'top-left', title: 'Copied'} )">
                                    Copy
                                </a>
                            </dd>

                            <dt>SSID Password</dt>
                            <dd v-if="networkCredential.ssid.password">
                                <hidden-string :value="networkCredential.ssid.password"></hidden-string>

                                <a href="javascript://void(0)"
                                   v-clipboard="() => networkCredential.ssid.password"
                                   @success="$notify( { type: 'success', placement: 'top-left', title: 'Copied'} )">
                                    Copy
                                </a>
                            </dd>

                            <dt>Username</dt>
                            <dd>
                                {{networkCredential.username}}
                                <a href="javascript://void(0)"
                                   v-clipboard="() => networkCredential.username"
                                   @success="$notify( { type: 'success', placement: 'top-left', title: 'Copied'} )">
                                    Copy
                                </a>
                            </dd>

                            <dt>Password</dt>
                            <dd>
                                <hidden-string :value="networkCredential.password"></hidden-string>

                                <a href="javascript://void(0)"
                                   v-clipboard="() => networkCredential.password"
                                   @success="$notify( { type: 'success', placement: 'top-left', title: 'Copied'} )">
                                    Copy
                                </a>
                            </dd>
                        </dl>
                    </div>
                </div>

                <form @submit.prevent="createNetworkAccess" accept-charset="UTF-8"
                      data-vv-scope="networkAccess" novalidate="novalidate" v-if="!networkAccess.id">
                    <input id="network-access-accessible-type"
                           v-validate="'required'"
                           v-model="networkAccess.accessible_type"
                           name="NetworkAccess[accessible_type]"
                           type="hidden">

                    <input id="network-access-accessible-id"
                           v-validate="'required'"
                           v-model="networkAccess.accessible_id"
                           name="NetworkAccess[accessible_id]"
                           type="hidden">

                    <input id="network-credential-ssid-id"
                           v-if="project.network_type === 1"
                           v-validate="'required'"
                           v-model="ssid.id"
                           name="NetworkCredential[ssid_id]"
                           type="hidden">

                    <!-- NetworkAccess[accessible_type] -->
                    <div class="form-group has-feedback"
                         v-if="!accessibleType"
                         :class="{'has-error': errors.has('networkAccess.NetworkAccess[accessible_type]')}">
                        <label>&nbsp;</label>

                        <div class="btn-group btn-group-justified" role="group">
                            <div class="btn-group" role="group">
                                <button type="button"
                                        :class="{ active: networkAccess.accessible_type === 'App\\Resident' }"
                                        class="btn btn-sm btn-success"
                                        @click="networkAccess.accessible_type = 'App\\Resident'">
                                    Resident
                                </button>
                            </div>
                            <div class="btn-group" role="group">
                                <button type="button"
                                        :class="{ active: networkAccess.accessible_type === 'App\\User' }"
                                        class="btn btn-sm btn-primary"
                                        @click="networkAccess.accessible_type = 'App\\User'">
                                    User
                                </button>
                            </div>
                        </div>

                        <span v-show="errors.has('networkAccess.NetworkAccess[accessible_type]')" class="help-block">
                            {{ errors.first('networkAccess.NetworkAccess[accessible_type]') }}
                        </span>
                    </div>

                    <!-- NetworkAccess[accessible_id] -->
                    <div class="form-group has-feedback"
                         v-if="!accessibleId"
                         :class="{'has-error': errors.has('networkAccess.NetworkAccess[accessible_id]')}">
                        <!-- Use v-show to avoid template conflicts-->
                        <auto-complete
                            @change="setAccessible"
                            class="form-group"
                            name="NetworkAccess[accessible_id]"
                            label="Resident"
                            :query-string="'limit=5&project_id=' + projectId + '&withoutNetworkAccess=withoutNetworkAccess'"
                            search-results-index="Residents"
                            find-result-index="Resident"
                            resource-url="/api/residents"
                            ref="residentAutoComplete"
                            v-show="networkAccess.accessible_type === 'App\\Resident'">
                            <template slot-scope="resident" slot="model-display">
                                {{resident.first_name}} {{resident.last_name}} {{resident.unit ? '(Apt '
                                + resident.lease.unit + ')' : ''}}
                            </template>
                        </auto-complete>

                        <!-- Use v-show to avoid template conflicts-->
                        <auto-complete
                            @change="setAccessible"
                            class="form-group"
                            name="NetworkAccess[accessible_id]"
                            label="User"
                            :query-string="'limit=5&project_id=' + projectId + '&networkAccess=networkAccess&_load[]=address'"
                            search-results-index="Users"
                            find-result-index="User"
                            resource-url="/api/users"
                            ref="userAutoComplete"
                            v-show="networkAccess.accessible_type === 'App\\User'">
                            <template slot-scope="user" slot="model-display">
                                {{user.first_name}} {{user.last_name}} ({{user.email}})
                            </template>
                        </auto-complete>

                        <span v-show="errors.has('networkAccess.NetworkAccess[accessible_id]')" class="help-block">
                            {{ errors.first('networkAccess.NetworkAccess[accessible_id]') }}
                        </span>
                    </div>

                    <div v-if="project && !networkCredentialId">
                        <!-- Distributed Project -->
                        <div class="form-group" v-if="project.network_type === 1">
                            <p>Search and select the correct Network Credential</p>

                            <dl>
                                <dt v-if="accessible.fullName">{{accessible.fullName}}</dt>
                                <dd v-if="accessible.lease && accessible.lease.unit">Apt: {{accessible.lease.unit}}</dd>

                                <dd v-if="accessible.address && ( accessible.address || accessible.address_2 )">
                                    <span v-if="accessible.address.address">{{accessible.address.address}}</span>
                                    <span v-if="accessible.address.address_2">{{accessible.address.address_2}}</span>
                                </dd>

                                <dd v-if="accessible.address && ( accessible.address.city || accessible.address.state || accessible.address.postal_code )">
                                    <span v-if="accessible.address.city">{{accessible.address.city}}</span>
                                    <span v-if="accessible.address.state">{{accessible.address.state}}</span>
                                    <span
                                        v-if="accessible.address.postal_code">{{accessible.address.postal_code}}</span>
                                </dd>
                            </dl>

                            <div class="row">
                                <div class="form-group col-md-9 col-lg-7">
                                    <div class="input-group">
                                        <input name="q" class="form-control" v-model="ssidSearch"
                                               v-on:keyup.enter="loadSSIDs">

                                        <span class="input-group-btn">
                                        <button type="button" class="btn btn-primary" @click="loadSSIDs">
                                            <i aria-hidden="true" class="fa fa-search"></i>
                                        </button>
                                    </span>
                                    </div>
                                </div>
                            </div>

                            <span v-show="errors.has('networkAccess.NetworkCredential[ssid_id]')" class="help-block">
                                Please select an SSID
                            </span>

                            <div class="list-group">
                                <a href="javascript://void(0)" v-for="listSSID in ssids"
                                   class="list-group-item selectable"
                                   @click="ssid = listSSID"
                                   :class="{ 'active list-group-item-success': listSSID.id === ssid.id }">
                                    <h5 v-if="listSSID.address">
                                        {{listSSID.address.full_address}}
                                    </h5>
                                    <h6>{{listSSID.name}}</h6>
                                </a>
                            </div>

                            <span v-show="errors.has('networkAccess.NetworkCredential[ssid_id]') && ssids.length !== 0"
                                  class="help-block">
                                Please select an SSID
                            </span>
                        </div>

                        <div v-else-if="accessibleType === 'App\\User' && !accessible.address">
                            <div class="form-group has-feedback"
                                 :class="{'has-error': errors.has('networkAccess.Address[address]')}">
                                <label for="address-address">Address</label>

                                <input id="address-address"
                                       v-validate="'required'"
                                       v-model="address.address"
                                       name="Address[address]"
                                       type="text"
                                       class="form-control"
                                       aria-required="true">

                                <span v-show="errors.has('networkAccess.Address[address]')" class="help-block">
                                    {{ errors.first('networkAccess.Address[address]') }}
                                </span>
                            </div>

                            <div class="form-group has-feedback"
                                 :class="{'has-error': errors.has('networkAccess.Address[address_2]')}">
                                <label for="address-address-2">Address 2</label>

                                <input id="address-address-2"
                                       v-model="address.address_2"
                                       name="Address[address_2]"
                                       type="text"
                                       class="form-control"
                                       aria-required="true">

                                <span v-show="errors.has('networkAccess.Address[address_2]')" class="help-block">
                                {{ errors.first('networkAccess.Address[address_2]') }}
                            </span>
                            </div>

                            <div class="row">
                                <div class="col-sm-4 form-group has-feedback"
                                     :class="{'has-error': errors.has('networkAccess.Address[city]')}">
                                    <label for="address-city">City</label>

                                    <input id="address-city"
                                           v-validate="'required'"
                                           v-model="address.city"
                                           name="Address[city]"
                                           type="text"
                                           class="form-control"
                                           aria-required="true">

                                    <span v-show="errors.has('networkAccess.Address[city]')" class="help-block">
                                        {{ errors.first('networkAccess.Address[city]') }}
                                    </span>
                                </div>

                                <div class="col-sm-4 form-group has-feedback"
                                     :class="{'has-error': errors.has('networkAccess.Address[state]')}">
                                    <label for="address-state">State</label>

                                    <select id="address-state"
                                            v-validate="'required'"
                                            v-model="address.state"
                                            name="Address[state]"
                                            class="form-control">
                                        <option value="">-</option>
                                        <option v-for="(state, abbreviation) in states" :value="abbreviation">
                                            {{state}}
                                        </option>
                                    </select>

                                    <span v-show="errors.has('networkAccess.Address[state]')" class="help-block">
                                        {{ errors.first('networkAccess.Address[state]') }}
                                    </span>
                                </div>

                                <div class="col-sm-4 form-group has-feedback"
                                     :class="{'has-error': errors.has('networkAccess.Address[postal_code]')}">
                                    <label for="address-postal-code">Postal Code</label>

                                    <input id="address-postal-code"
                                           v-validate="'required'"
                                           v-model="address.postal_code"
                                           name="Address[postal_code]"
                                           type="text"
                                           class="form-control"
                                           aria-required="true">

                                    <span v-show="errors.has('networkAccess.Address[postal_code]')" class="help-block">
                                        {{ errors.first('networkAccess.Address[postal_code]') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="checkbox">
                        <label>
                            <input id="network-access-send-notifications"
                                   type="checkbox"
                                   v-model.boolean="networkAccess.send_notifications">

                            Welcome Notification
                        </label>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-xs-6 form-group pull-right">
                            <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                Save
                            </button>
                        </div>
                    </div>
                </form>

                <!--if networkAccess.id-->
                <div v-else>
                    <tabs>
                        <tab :title="'Email Notifications (' + networkAccess.emailNotifications.length + ')'"
                             v-if="networkAccess.deleted_at === null &&
                                   networkAccess.networkCredential.deleted_at === null &&
                                   accessible &&
                                   accessible.enrolled">
                            <fieldset>
                                <legend>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                                            Email Notifications
                                        </div>

                                        <div class="col-sm-6 col-md-5 form-group align-sm-left" v-if="email">
                                            <button type="button" class="btn btn-sm"
                                                    :class="{
                                                        'btn-success': !showEmailNotification,
                                                        'btn-default': showEmailNotification }"
                                                    @click="showEmailNotification = !showEmailNotification">

                                                <span v-if="!showEmailNotification">
                                                    Schedule Notification
                                                </span>
                                                <span v-else>
                                                    Cancel
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </legend>

                                <div v-if="!email">
                                    <h5>No contact email available. Please update the {{accessibleTypeName}} email.</h5>
                                </div>

                                <form @submit.prevent="scheduleNotification" accept-charset="UTF-8"
                                      novalidate="novalidate"
                                      data-vv-scope="emailNotification" v-if="showEmailNotification">

                                    <div class="form-group has-feedback"
                                         :class="{'has-error': errors.has('emailNotification.EmailNotification[template]')}">
                                        <label for="email-notification-template">Email Type</label>

                                        <select id="email-notification-template"
                                                v-validate="'required'"
                                                v-model="emailNotification.template"
                                                name="EmailNotification[template]"
                                                class="form-control">
                                            <option value="">-</option>
                                            <option v-for="(value, label) in emailTemplateOptions" :value="value">
                                                {{label}}
                                            </option>
                                        </select>

                                        <span v-show="errors.has('emailNotification.EmailNotification[template]')"
                                              class="help-block">
                                            {{ errors.first('emailNotification.EmailNotification[template]') }}
                                        </span>
                                    </div>

                                    <hr>

                                    <div class="form-group">
                                        <button type="submit" class="btn btn-success" :disabled="loading">
                                            Send Notification
                                        </button>
                                    </div>
                                </form>

                                <ul class="list-group no-margin" v-if="networkAccess.emailNotifications">
                                    <li class="list-group-item link"
                                        :class="{
                                            'active list-group-item-success': !emailNotification.sent_at && emailNotification.id === listEmailNotification.id
                                        }"
                                        v-for="listEmailNotification in networkAccess.emailNotifications"
                                        @click="emailNotification = listEmailNotification">

                                        <h5 class="margin-sm-bottom">
                                            {{listEmailNotification.subject}}
                                        </h5>

                                        <h6 class="margin-sm-bottom">
                                            <a :href="'mailto:' + listEmailNotification.to">{{listEmailNotification.to}}</a>
                                        </h6>

                                        <div class="row">
                                            <div class="col-sm-7">
                                                <span class="label label-success"
                                                      v-if="listEmailNotification.sent_at !== null">
                                                    Sent at {{listEmailNotification.sent_at}}
                                                </span>
                                                <span class="label label-warning" v-else>
                                                    Pending Send
                                                </span>
                                            </div>
                                            <div class="col-sm-5 align-sm-right"
                                                 v-if="!emailNotification.sent_at && listEmailNotification.id === emailNotification.id">
                                                <button class="btn btn-sm btn-warning" type="button"
                                                        @click="deleteEmailNotification(emailNotification)">
                                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </fieldset>
                        </tab>
                        <tab title="Edit">
                            <hr>

                            <div class="row">
                                <div class="col-xs-6">
                                    <button type="button" class="btn btn-sm btn-warning"
                                            @click="deleteNetworkAccess"
                                            v-if="networkAccess.id && networkAccess.deleted_at === null"
                                            :disabled="loading">
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>

                                    <button type="button" class="btn btn-sm btn-warning"
                                            @click="restoreNetworkAccess"
                                            v-if="networkAccess.id && networkAccess.deleted_at"
                                            :disabled="loading">
                                        <i class="fa fa-refresh" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </tab>
                    </tabs>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    const { states } = require( '../constants.json' );
    const pluralize = require( 'pluralize' );

    export default {
        props: {
            accessibleId: {
                default: null,
                type: String,
            },

            accessibleType: {
                default: null,
                type: String,
            },

            afterSave: {
                default(){
                    return function(){
                        window.location.reload();
                    };
                }
            },

            modalId: {
                default: Math.random().toString(),
                type: String
            },

            networkAccessId: {
                default: null,
                type: String,
            },

            networkCredentialId: {
                default: null,
                type: String,
            },

            projectId: {
                required: true,
                type: String,
            },
        },

        created(){
            this.init();
        },

        data(){
            return {
                loading: true,

                showEmailNotification: false,

                accessible: {},

                address: {},

                emailTemplateOptions: {
                    'Network Access Invitation': 'resident.network-access-create',
                    'Updated Password': 'resident.network-access-update'
                },

                emailNotification: {
                    template: 'resident.network-access-create',
                },

                networkAccess: {
                    accessible_id: null,
                    accessible_type: 'App\\Resident',
                    send_notifications: true,
                },

                ssidSearch: '',
                networkCredential: {},

                ssids: [],
                ssid: {},

                project: {},

                states: states,
            };
        },
        computed: {
            email(){
                if( this.networkAccess ){
                    if( this.networkAccess.accessible_type === 'App\\Resident' ){
                        return this.accessible.contactEmail;
                    }
                    else if( this.networkAccess.accessible_type === 'App\\User' ){
                        return this.accessible.email;
                    }
                }
            },

            accessibleTypeName(){
                if( this.networkAccess ){
                    return this.networkAccess.accessible_type.replace( "App\\", "" );
                }
            },
        },
        watch: {
            networkAccessId(){
                this.$nextTick( () => {
                    this.init();
                } );
            },

            'networkAccess.accessible_type'(){
                this.$nextTick( () => {
                    if( this.$refs.residentAutoComplete ){
                        this.$refs.residentAutoComplete.reset();
                    }

                    if( this.$refs.userAutoComplete ){
                        this.$refs.userAutoComplete.reset();
                    }
                } );
            }
        },
        methods: {
            init(){
                this.loading = true;

                var promises = [
                    this.loadProject(),
                ];

                if( this.networkAccessId ){
                    this.networkAccess.id = this.networkAccessId;

                    promises.push( this.loadNetworkAccess() );
                }
                else {
                    if( this.networkCredentialId ){
                        this.networkCredential.id = this.networkCredentialId;

                        promises.push( this.loadNetworkCredential() );
                    }

                    if( this.accessibleId ){
                        this.networkAccess.accessible_id = this.accessibleId;
                    }

                    if( this.accessibleType ){
                        this.networkAccess.accessible_type = this.accessibleType;
                    }
                }

                return Promise.all( promises )
                    .then( () => {
                        var dependantPromises = [];

                        this.initFields();

                        if( this.networkAccess.accessible_id ){
                            dependantPromises.push( this.loadAccessible() );
                        }

                        return Promise.all( dependantPromises );
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            initFields(){
                if( this.accessibleType === 'App\\User' && _.isObject( this.project.property.address ) ){
                    this.address.city = this.project.property.address.city;
                    this.address.state = this.project.property.address.state;
                    this.address.postal_code = this.project.property.address.postal_code;
                }
            },

            loadAccessible(){
                var url = '/api/';
                var index = _.replace( this.networkAccess.accessible_type, 'App\\', '' );

                url += pluralize( _.camelCase( index ) ) + '/' + this.networkAccess.accessible_id;

                if( this.accessibleType === 'App\\User' ){
                    url += '?_load[]=address';
                }

                return axios.get( url )
                    .then( ( response ) => {
                        this.$set( this, 'accessible', response.data[ index ] );
                    } );
            },

            loadProject(){
                var url = '/api/projects/' + this.projectId;

                return axios.get( url )
                    .then( ( response ) => {
                        var project = response.data.Project;

                        this.$set( this, 'project', project );
                    } );
            },

            loadNetworkAccess(){
                var url = '/api/networkAccesses/' + this.networkAccess.id;

                return axios.get( url )
                    .then( ( response ) => {
                        var networkAccess = response.data.NetworkAccess;

                        if( networkAccess.networkCredential ){
                            this.$set( this, 'networkCredential', networkAccess.networkCredential );
                        }

                        this.$set( this, 'networkAccess', networkAccess );
                    } );
            },

            loadNetworkCredential(){
                return axios.get( '/api/networkCredentials/' + this.networkCredentialId )
                    .then( ( response ) => {
                        this.$set( this, 'networkCredential', response.data.NetworkCredential );

                        if( response.data.NetworkCredential.ssid ){
                            this.$set( this, 'ssid', response.data.NetworkCredential.ssid );
                        }
                    } );
            },

            loadSSIDs(){
                this.loading = true;

                return axios.get( '/api/ssids?_with[]=address&limit=10&project_id=' + this.projectId + '&q=' + this.ssidSearch )
                    .then( ( response ) => {
                        this.$set( this, 'ssids', response.data.SSIDs );
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            setAccessible( accessibleId, accessible ){
                this.accessible = accessible;
                this.networkAccess.accessible_id = accessibleId;
            },

            // Network Access
            createNetworkAccess(){
                return this.$validator.validateAll( 'networkAccess' )
                    .then( ( valid ) => {
                        if( !valid ){
                            return false;
                        }

                        this.loading = true;

                        if( this.networkCredential.id ){
                            this.networkAccess.network_credential_id = this.networkCredential.id;
                        }

                        var data = {
                            NetworkAccess: this.networkAccess,
                            NetworkCredential: {
                                project_id: this.projectId
                            }
                        };

                        if( this.project.network_type === 0 && this.networkAccess.accessible_type === 'App\\User' ){
                            if( this.accessible.address ){
                                data.Address = this.accessible.address;
                            }
                            else {
                                data.Address = this.address;
                            }
                        }

                        if( this.project.network_type === 1 ){
                            data.NetworkCredential.ssid_id = this.ssid.id;
                        }

                        return axios.post( '/api/networkAccesses', data )
                            .then( ( result ) => {
                                if( !this.networkAccess.id ){
                                    this.networkAccess = result.data.NetworkAccess;
                                }
                            } )
                            .then( this.loadNetworkAccess )
                            .then( () => {
                                this.afterSave();

                                this.$notify( {
                                    type: 'success',
                                    placement: 'top-left',
                                    title: 'Network Access Granted',
                                } );
                            } )
                            .finally( () => {
                                this.loading = false;
                            } )
                            .catch( this.$root.handleErrors );
                    } );
            },

            deleteNetworkAccess(){
                var url = '/api/networkAccesses/' + this.networkAccess.id;

                return axios.delete( url )
                    .then( () => {
                        this.resetData();

                        this.$modal.hide( this.modalId );
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Network Access Revoked',
                        } );

                        this.afterSave();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            restoreNetworkAccess(){
                var url = '/api/networkAccesses/' + this.networkAccess.id + '/restore';

                return axios.put( url )
                    .then( ( result ) => {
                        if( !this.networkAccess.id ){
                            this.networkAccess = result.data.NetworkAccess;
                        }

                        return this.loadNetworkAccess();
                    } )
                    .then( () => {
                        this.afterSave();

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Network Access Restored',
                        } );
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            // Email Notification
            deleteEmailNotification( emailNotification ){
                return axios.delete( '/api/emailNotifications/' + emailNotification.id )
                    .then( () => {
                        return this.loadNetworkAccess();
                    } )
                    .then( () => {
                        this.afterSave();

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Archived Email Notification',
                        } );
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        this.$root.handleErrors( err, 'notifications' );
                    } );
            },

            scheduleNotification(){
                var url = '/api/networkAccesses/' + this.networkAccess.id + '/scheduleNotifications';

                return this.$validator.validateAll( 'emailNotification' )
                    .then( ( valid ) => {
                        if( valid && this.networkAccess.id ){
                            this.loading = true;

                            return axios.post( url, {
                                EmailNotification: {
                                    template: this.emailNotification.template
                                }
                            } )
                                .then( ( result ) => {
                                    this.emailNotificaiton = result.data.EmailNotification;

                                    return this.loadNetworkAccess();
                                } )
                                .then( () => {
                                    this.afterSave();

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Email Notifications Scheduled',
                                    } );

                                    this.showEmailNotification = false;
                                } )
                                .finally( () => {
                                    this.loading = false;
                                } )
                                .catch( this.$root.handleErrors );
                        }
                    } );
            },

            beforeClose(){
                this.resetData();
                this.$emit( 'before-close' );

                this.$nextTick( () => {
                    this.init();
                } );
            },

            resetData(){
                Object.assign( this.$data, this.$options.data() );
            },

            closeModal(){
                this.$modal.hide( this.modalId );
            },

            openModal(){
                this.$modal.show( this.modalId );
            }
        }
    }
</script>
